import { render } from "./contact-tab.vue?vue&type=template&id=0c883e70&scoped=true"
import script from "./contact-tab.vue?vue&type=script&lang=js"
export * from "./contact-tab.vue?vue&type=script&lang=js"

import "./contact-tab.vue?vue&type=style&index=0&id=0c883e70&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c883e70"]])

export default __exports__